module.exports = __webpack_public_path__ + "img/cbv-01.327d700b.jpg";